<template>
    <div class="d-flex flex-row" style="width: 50rem">
        <div
            v-lazy-container="{ selector: 'img' }"
            class="d-flex flex-column justify-content-center align-items-center pt-0 p-5"
        >
            <img
                data-src="/logo/iRender-fulltext.svg"
                alt=""
                style="width: 5rem"
            />
            <img
                class="mt-3"
                data-src="/image/fixed-rental/fixed-rental-bg.svg"
                alt=""
                style="width: 17.5rem"
            />
        </div>
        <div
            class="d-flex flex-column p-2 pl-10 pr-5"
            style="border-left: 1px solid #eeeeee"
        >
            <div
                style="
                    font-size: 0.95rem;
                    color: #42a5f5;
                    font-family: Montserrat;
                    font-weight: 600;
                    text-align: center;
                "
            >
                {{ $t('fixedRentalDescription.rentalPlanLabel') }}
            </div>
            <div
                class="mt-5"
                style="
                    font-family: Montserrat;
                    text-align: justify;
                    font-size: 0.7rem;
                "
            >
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;" {{ $t('fixedRentalDescription.introText') }} "
            </div>
            <div class="mt-5" style="font-size: 0.8rem">
                <div style="font-weight: 600">{{ $t('fixedRentalDescription.description') }}</div>
                <div class="ml-3">
                    <div class="mt-2">
                        •&nbsp;&nbsp;{{ $t('fixedRentalDescription.descriptionNoRefund') }}
                    </div>
                    <div class="mt-2">•&nbsp;&nbsp;{{ $t('fixedRentalDescription.descriptionTime') }}</div>
                </div>
                <div class="mt-5" style="font-weight: 600">{{ $t('fixedRentalDescription.requirements') }}</div>
                <div
                    class="mt-2 ml-3"
                    style="color: #bdbdbd; font-style: italic"
                >
                    {{ $t('fixedRentalDescription.noRequirements') }}
                </div>
            </div>
            <div class="d-flex justify-content-center mt-10">
                <el-button
                    @click="skipDescription"
                    class="pl-10 pr-10"
                    type="primary"
                    round
                    >{{ $t('fixedRentalDescription.continueButton') }}<i
                        class="el-icon-arrow-right el-icon-right ml-3"
                    ></i
                ></el-button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    methods: {
        skipDescription() {
            this.$emit("processingEvent", {
                event: "skipDescription",
                data: false,
            });
        },
    },
};
</script>